import { gql } from "@apollo/client/core";

export default gql`
  query TmReportsCarboneReport(
    $dateFrom: String!
    $dateTo: String!
      $locationIds: [String!]!
      $type: String!
  ) {
    getSingleProjectExport(
      dateFrom: $dateFrom
      dateTo: $dateTo
      locationIds: $locationIds
      type: $type
    )
  }
`;
